export const STORAGE_BUCKETS = {
  PRODUCT_IMAGES: 'productimages',
  ILLUSTRATION_LOGOS: 'illustration-logos',
} as const

export const STORAGE_PATHS = {
  PRODUCT_COLORS: 'product-colors',
} as const

export const SCROLL_HEIGHTS = {
  NEW_COLOR_IMAGES: 'max-h-[300px]',
  NEW_COLOR_IMAGES_EMPTY: 'h-0',
  COLOR_ITEM_NEW_IMAGES: 'h-[150px]',
  COLOR_ITEM_IMAGES: 'h-[300px]',
  MAIN_CONTAINER: 'h-[580px]',
} as const
